import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function renderMarkdown(text) {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                a: ({node, children, ...props}) => (
                    <a
                        {...props}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:text-blue-700 underline"
                    >{children}</a>
                ),
                pre: ({node, ...props}) => (
                    <div className="bg-gray-100 p-4 rounded-lg my-4 overflow-x-auto">
                        <pre {...props} />
                    </div>
                ),
                code: ({node, inline, ...props}) => (
                    inline ?
                        <code className="bg-gray-100 px-1 rounded" {...props} /> :
                        <code {...props} />
                )
            }}
        >
            {text}
        </ReactMarkdown>
    );
}
